import React, { Component } from 'react';
import styled from 'styled-components';
import { PrestoAppTheme, PrestoAppUtils } from 'presto-mini-apps-lib';
import {
    isPrestoPayMethod,
    PaymentType
} from '../../constants/appState';
import { term_change, term_onlinebanking } from '../../constants/text';

class PaymentTypeSelector extends Component {
    constructor(props) {
        super(props);

        this.state = {
            paymentType: '',
            paymentTypeDetails: { icon: <i />, iconHover: <i />, label: '' },
            hasSufficientBalance: true,
            isSelectorOpen: false,
            isOnlineBankingSelected: false,
        }
    }

    componentDidMount() {
    }

    componentDidUpdate(prevProps) {
        const { selectedIndex } = this.props;
        if(prevProps.selectedIndex !== selectedIndex) {
            this.setState({
                paymentType: selectedIndex,
                paymentTypeDetails: this.getArrayByID(selectedIndex) !== undefined ? this.getArrayByID(selectedIndex) : this.getOnlineBankArrayByID(selectedIndex)
            });
        }
    }

    onToggleHandler = (e) => {
        const { disabled, allowToggle } = this.props;
        const { paymentType } = this.state;
        if (!!disabled) {
            return;
        }

        if (allowToggle && !allowToggle(paymentType)) {
            return;
        }


        this.setState({
            isSelectorOpen: !this.state.isSelectorOpen
        })
    };

    onSelectHandler = (id, balance) => {
        const { onSelectInput, appState } = this.props;
        const { isOnlineBankingSelected } = this.state;

        if (PaymentType.PRESTOWALLET === id && !appState.isGuest && balance === 0) {
            return;
        }

        if (id === PaymentType.ONLINEBANK) {
            this.setState({
                isSelectorOpen: true,
                isOnlineBankingSelected: true
            });
            document.getElementById('payment-type-selection-list').scrollTop = 0;
            return;
        }

        this.setState({
            paymentType: id,
            paymentTypeDetails: isOnlineBankingSelected ? this.getOnlineBankArrayByID(id) : this.getArrayByID(id),
            isSelectorOpen: false,
            isOnlineBankingSelected: appState.isGuest && isOnlineBankingSelected
        });

        if(typeof onSelectInput === 'function') onSelectInput(id);
    };

    getPaymentTypeBalance = (paymentType) => {
        if(!!this.getArrayByID(paymentType)) {
            return this.getArrayByID(paymentType).balance;
        }
        return 0;
    };

    getArrayByID = (id) => {
        const { paymentList } = this.props;
        let _arr = paymentList.filter(item => (item.id === id));

        return _arr[0];
    };

    getOnlineBankArrayByID = (id) => {
        const { onlineBankList } = this.props;
        let _arr = onlineBankList.filter(item => (item.id === id));

        return _arr[0];
    };

    onBackFromOnlineBanking = () => {
        this.setState({
            isOnlineBankingSelected: false
        });
        document.getElementById('payment-type-selection-list').scrollTop = 0;
    };

    render() {
        const { 
            paymentType,
            paymentTypeDetails,
            isSelectorOpen,
            isOnlineBankingSelected
        } = this.state;
        const { 
            appState, 
            paymentList,
            onlineBankList,
            showError,
            errorMessage,
            disabled
        } = this.props;

        // if (!appState.isGuest && !!paymentList && paymentType === '') {
        //     this.setState({
        //         paymentType: paymentList[0].id,
        //         paymentTypeDetails: this.getArrayByID(paymentList[0].id)
        //     });
        // }

        const isOnlineBankingMethodSelected = this.getOnlineBankArrayByID(paymentType) !== undefined;
        const paymentTypeDisplayName = isOnlineBankingSelected && !isOnlineBankingMethodSelected ? term_onlinebanking :
                paymentType === '' ? "" :
                    isOnlineBankingMethodSelected ? term_onlinebanking + " - " + paymentTypeDetails.label :
                        paymentTypeDetails.label;
        const paymentTypeDisplayAmount = (isOnlineBankingSelected && !isOnlineBankingMethodSelected) || !isPrestoPayMethod(paymentType) ? null : appState.curCode.currency + PrestoAppUtils.convertToCurrency(this.getPaymentTypeBalance(paymentType) / 100);
        const paymentTypeDetailsDisplay = isOnlineBankingSelected && !isOnlineBankingMethodSelected ? this.getArrayByID(PaymentType.ONLINEBANK) : paymentTypeDetails;

        return ( !!paymentList ? (
            <React.Fragment>
                <PaymentTypeSelectorWrapper 
                    className={[
                        "payment-type-selector",
                        (appState.isGuest || isSelectorOpen || paymentType === '' ? ' open' : ''),
                        (!!showError ? ' has-error' : '')
                    ].join('')}>
                    {( (!appState.isGuest || isOnlineBankingSelected) && (
                        <div className={[
                            "preview-area",
                            (!disabled ? ' active' : '')
                        ].join('')} onClick={this.onToggleHandler}>
                            <div className="selected-payment">
                                <PaymentTypeName
                                    icon={paymentTypeDetailsDisplay.iconHover}
                                    iconActive={paymentTypeDetailsDisplay.icon}
                                    name={paymentTypeDisplayName}
                                    amount={paymentTypeDisplayAmount}
                                    selectedIcon={!appState.isGuest ? "changeLabel" : null}
                                />
                            </div>
                        </div>
                    ))}
                    <div className="selection-area">
                        {( !appState.isGuest && (
                            <div className="divider" />
                        ))}
                        <div id="payment-type-selection-list" className="selection-list-container">
                            <ul>
                                {(isOnlineBankingSelected ? onlineBankList : paymentList).map((item, key) => {
                                    return (
                                        <li key={key}
                                            onClick={() => this.onSelectHandler(item.id, item.balance)}
                                            className={[
                                                "selection-list",
                                                (item.id === paymentType || (item.id === PaymentType.ONLINEBANK && this.getOnlineBankArrayByID(paymentType) !== undefined) ? ' active' : ''),
                                                ((PaymentType.PRESTOWALLET === item.id && !appState.isGuest && item.balance === 0) ? ' disabled' : '')
                                            ].join('')}>
                                            <span className="payment-name">
                                                <PaymentTypeName
                                                    icon={item.iconHover}
                                                    iconActive={item.icon}
                                                    name={(item.id === PaymentType.ONLINEBANK && this.getOnlineBankArrayByID(paymentType) !== undefined) ? item.label + " - " + paymentTypeDetails.label : item.label}
                                                    amount={ !isPrestoPayMethod(item.id) || appState.isGuest
                                                        ? null
                                                        : appState.curCode.currency + PrestoAppUtils.convertToCurrency(item.balance / 100)}
                                                    selectedIcon={ item.id === PaymentType.ONLINEBANK && this.getOnlineBankArrayByID(paymentType) !== undefined ? "changeLabel" : "checked" }
                                                />
                                            </span>
                                        </li>
                                    );
                                    })
                                }
                                {(isOnlineBankingSelected) && (
                                    <li onClick={this.onBackFromOnlineBanking}
                                        className={[
                                            "selection-list"
                                        ].join('')}>
                                            <span className="payment-name back-selection">
                                                <PaymentTypeName
                                                    name="Back"
                                                    icon={<i />}
                                                    icon-active={<i />}
                                                    amount={null}
                                                />
                                            </span>
                                    </li>
                                )}

                            </ul>
                        </div>
                    </div>
                </PaymentTypeSelectorWrapper>
                
                { showError && (
                    <ErrorMessageWrapper className="error-message">
                        {errorMessage}
                    </ErrorMessageWrapper>
                )}
            </React.Fragment>
        ) : null );
    }
}

export default PaymentTypeSelector;


const PaymentTypeName = ({icon, iconActive, name, amount, selectedIcon}) => (
    <PaymentTypeNameWrapper className="payment-type-name">
        { !!icon && <div className="icon">{icon}</div> }
        { !!iconActive && <div className="icon-active">{iconActive}</div> }
        <div className="name">{name} { !!amount ? (<label>({amount})</label>) : null }</div>
        <div className="selectedIcon">
            { selectedIcon === "changeLabel" && (
                <div className="change-action">{term_change}</div>
            ) }
            { selectedIcon === "checked" && (
                <div className="checkedIcon"><img src={PrestoAppTheme.images.CheckIcon.src} alt="Checked" /></div>
            ) }
        </div>
    </PaymentTypeNameWrapper>
);

const iconSize = PrestoAppTheme.layout.fontSizeXLarge;
const iconWidth = "4.0rem";
const PaymentTypeNameWrapper = styled.div`
    display: flex;
    justify-content: space-between;

    & .icon, 
    & .icon-active { 
        height: ${iconSize};
        width: ${iconWidth};
        margin-right: ${PrestoAppTheme.layout.xSmallGap};
        text-align: center;
    
        & > img {
            max-width: 100%;
            max-height: 100%;
        }
    }

    & .icon { 
        display: block;
    }
    
    & .icon-active { 
        display: none;
    }
    
    & .name { 
        font-weight: 400;
        margin-right: ${PrestoAppTheme.layout.xSmallGap};
        width: 100%;
        line-height: 1.2rem;
    }
    
    & .selectedIcon {
        width: 5.5rem;
        overflow: hidden;
        text-align: right;
        height: 20px;
    }

    .active .payment-name & {
        & .icon { 
            display: none;
        }
        
        & .icon-active { 
            display: block;
        }
        
        & .name {
            color: rgb(${PrestoAppTheme.colors.prestoRedRGB}) !important;
        }
    }
    
    .disabled & {
        & .name {
            color: #CCCCCC;
        }
    }
    
    .selected-payment & {
        & .name {
            color: #CCCCCC;
        }
    }
    
    .active .selected-payment & {
        & .icon { 
            display: none;
        }
        
        & .icon-active { 
            display: block;
        }
        
        & .name {
            color: #4A4A4A;
        }
    }
    
    .back-selection & {
        & .name {
            color: ${PrestoAppTheme.colors.baseBlue};
        }
    }
`;

const PaymentTypeSelectorWrapper = styled.div`
    padding: ${PrestoAppTheme.layout.smallGap} ${PrestoAppTheme.layout.smallGap} 0;
    border: 1px solid ${PrestoAppTheme.colors.baseSnowDark};
    border-radius: ${PrestoAppTheme.layout.borderRadius};

    &.has-error {
        border-radius: ${PrestoAppTheme.layout.borderRadius} ${PrestoAppTheme.layout.borderRadius} 0 0;
    }

    & .preview-area {
        display: flex;
        justify-content: space-between;
        padding-bottom: ${PrestoAppTheme.layout.smallGap};

        & .selected-payment {
            width: 100%;
        }

        & .change-action {
            font-weight: 400;
            text-align: right;
            color: #CCCCCC;
            line-height: 1.2rem;
        }
    }
    
    & .preview-area.active {
        & .change-action {
            color: ${PrestoAppTheme.colors.baseBlue};
            cursor: pointer;
        }
    }
    
    & .selection-area {
        width: calc(100% + 2 * ${PrestoAppTheme.layout.smallGap});
        margin-left: -${PrestoAppTheme.layout.smallGap};

        & .divider { 
            height: 0;
            background-color: ${PrestoAppTheme.colors.baseSnowDark};
            transition: height 10ms 300ms;
        }
        
        & .selection-list-container {
            max-height: 0;
            overflow: hidden;
            transition: max-height 300ms;

            & > ul {
                ${PrestoAppTheme.layout.blankListStyle}
                // padding-top: ${PrestoAppTheme.layout.smallGap};
    
                & .selection-list {
                    padding: 0.4rem ${PrestoAppTheme.layout.smallGap};
                    line-height: ${iconSize};
                    // color: ${PrestoAppTheme.colors.baseGrey};
                    color: ${PrestoAppTheme.colors.baseBlack};
                    cursor: pointer;
                    display: flex;
        
                    & .payment-name { 
                        display: inline-block;
                        margin-right: ${PrestoAppTheme.layout.xSmallGap};
                        vertical-align: middle;
                        width: 100%;
                    }

                    & .checkedIcon {
                        display: none;
                        height: ${iconSize};
                        width: ${iconSize};
                    }
                    
                    & .change-action {
                        display: none;
                        font-weight: 400;
                        text-align: right;
                        color: ${PrestoAppTheme.colors.baseBlue};
                        cursor: pointer;
                    }
                    
                    &.active {
                        justify-content: space-between;
                        
                        & .checkedIcon {
                            display: inline-block;
                        
                            & > img {
                                width: 100%;
                            }
                        }
                        
                        & .change-action {
                            display: inline-block;
                        }
                    }

                    &:hover {
                        background-color: ${PrestoAppTheme.colors.baseSnow};
                    }
                }
            }
        }
    }

    &.open {
        & .selection-area {
            & .divider { 
                height: 1px;
                transition: height 10ms 1ms;
            }
            
            & .selection-list-container {
                max-height: 300px;
                overflow: auto;
                transition: max-height 400ms;
                @media only screen and (max-width: 768px) {
                    max-height: 300px;
                }
                @media only screen and (max-width: 320px) {
                    max-height: 185px;
                }
            }
        }
    }
`;

const ErrorMessageWrapper = styled.div`
    padding: ${PrestoAppTheme.layout.smallGap};
    text-align: center;
    border-radius: 0 0 ${PrestoAppTheme.layout.borderRadius} ${PrestoAppTheme.layout.borderRadius};
    background-color: #ffe1b6;
    color: ${PrestoAppTheme.colors.baseBlack};

    & .title { 
        font-weight: 400;
        margin-bottom: ${PrestoAppTheme.layout.xSmallGap};
    }
`;